export default class UpdateOrganizationError extends Error {

}
